import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames";
import Icon from "../../../../components/Icon";
import { Range, Select, CheckList } from "../../../../components/Form";
export var Filter = function Filter(a) {
  var b = a.type,
      c = a.apiName,
      d = a.className,
      e = a.toggled,
      f = a.onToggle,
      g = a.required,
      h = _objectWithoutProperties(a, ["type", "apiName", "className", "toggled", "onToggle", "required"]),
      i = h.label,
      j = "range" === b,
      k = null;

  j && (k = /*#__PURE__*/React.createElement(Range, h)), "select" === b && (k = /*#__PURE__*/React.createElement(Select, h)), "check-list" === b && (k = /*#__PURE__*/React.createElement(CheckList, h));
  var l = "function" == typeof f;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(d, "ta-" + i.toLowerCase(), {
      isToggle: l,
      isActive: e
    })
  }, /*#__PURE__*/React.createElement("h3", {
    className: "ta-filter--title",
    onClick: l ? f : void 0
  }, i, " ", h.suffix ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "(".concat(h.suffix, ")")
    }
  }) : null, g ? /*#__PURE__*/React.createElement("span", {
    className: "ta-filter--title__error"
  }, " (Required)") : null, l && j ? /*#__PURE__*/React.createElement("span", {
    className: "selectedvalue"
  }, h.value ? Array.isArray(h.value) ? h.value.join("-") : "number" == typeof h.value ? h.value : h.value.replace("-", " - ") : "Any") : null, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ta-filter--item"
  }, k));
};
export default Filter;